import { values } from 'lodash-es';
import PropTypes from 'prop-types';
import {
  ProfileTypes,
  TargetViewers,
} from '../../constants/profileType.constant';
import { LikeType } from '../../constants/likeDetails.constant';
import PostUpdateReason from './postUpdateReason.type';

const PostPropType = PropTypes.shape({
  postAs: PropTypes.oneOf([ProfileTypes.Individual, ProfileTypes.Organization]),
  targetViewers: PropTypes.oneOf([
    TargetViewers.All,
    TargetViewers.MyOrg,
    TargetViewers.SelectedOrg,
  ]),
  createdOn: PropTypes.string,
  totalReactions: PropTypes.number,
  latestReactingUser: PropTypes.shape({
    id: PropTypes.number,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    likeType: PropTypes.oneOf([
      LikeType.clap,
      LikeType.love,
      LikeType.like,
      LikeType.support,
      LikeType.insightful,
      LikeType.funny,
    ]),
  }),
  likeInfo: PropTypes.shape({
    liked: PropTypes.bool,
    likeType: PropTypes.oneOf([
      LikeType.clap,
      LikeType.love,
      LikeType.like,
      LikeType.support,
      LikeType.insightful,
      LikeType.funny,
    ]),
  }),
  reactions: PropTypes.objectOf(PropTypes.number),
  totalComments: PropTypes.number,
  sourcePostData: PropTypes.shape({
    id: PropTypes.string,
    message: PropTypes.string,
    attachmentUrl: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string),
    ]),
    attachmentType: PropTypes.oneOf(['image', 'video']),
    nonProfitId: PropTypes.number,
  }),
  updatedFor: PropTypes.oneOf(values(PostUpdateReason)),
});

export default PostPropType;
